import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex h-11.5 w-11.5 items-center justify-center" }
const _hoisted_2 = { class: "flex h-11.5 w-11.5 items-center justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "absolute -top-0.5 -right-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold text-white"
}
const _hoisted_4 = { class: "flex h-11.5 w-11.5 items-center justify-center" }
const _hoisted_5 = { class: "ion-padding mt-[78px]" }

import useIsMobile from '@/composables/useIsMobile';
import { useAuthStore } from '@/store/auth';
import { useNotificationStore } from '@/store/notification';
import type { InfiniteScrollCustomEvent, RefresherCustomEvent } from '@ionic/vue';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonImg,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  IonSplitPane,
  IonToolbar,
  alertController,
  menuController,
} from '@ionic/vue';
import { Menu } from 'lucide-vue-next';
import { computed, onMounted, useAttrs } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import MobileMenu from '../ui/navigation/MobileMenu.vue';

    interface Props {
        title?: string;
        className?: string;
        ignoreHistory?: boolean;
        showBottomNav?: boolean;
        fullscreen?: boolean;
        hideNotification?: boolean;
        hideHeader?: boolean;
        hasRefresh?: boolean;
        withInfiniteScroll?: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BaseLayout',
  props: {
    title: {},
    className: {},
    ignoreHistory: { type: Boolean },
    showBottomNav: { type: Boolean },
    fullscreen: { type: Boolean },
    hideNotification: { type: Boolean },
    hideHeader: { type: Boolean },
    hasRefresh: { type: Boolean },
    withInfiniteScroll: { type: Boolean }
  },
  emits: ['refresh', 'loadMore'],
  setup(__props: any, { emit: __emit }) {

    const props = __props;
    const emit = __emit;

    const router = useRouter();
    const route = useRoute();
    const authStore = useAuthStore();
    const notificationStore = useNotificationStore();
    const isMobile = useIsMobile();

    const showSidebar = computed(() => {
        // Follow mobile app pattern - auth state is managed at router level
        // No need to initialize auth here, just use the current state
        if (!authStore.isAuthenticated) return false;
        if (!route.name) return false;

        return !['verify-otp', 'password-setup'].includes(route.name.toString());
    });

    onMounted(() => {
        if (authStore.isAuthenticated) {
            notificationStore.fetchCounts();
        }
    });

    // Function to open the mobile menu (for small screens)
    const openMobileMenu = async () => {
        const menuId = isMobile.value ? 'mobile-side-panel' : 'desktop-menu';
        await menuController.open(menuId);
    };

    const navigateTo = (path: string) => {
        router.push(`/${path}`);
    };

    // Navigation functions
    const goToSearch = () => {
        router.push('/search');
    };

    const goToNotifications = () => {
        router.push('/notifications');
    };

    const handleLogout = async () => {
        const alert = await alertController.create({
            header: 'Logout',
            message: 'Are you sure you want to logout?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                },
                {
                    text: 'Logout',
                    role: 'confirm',
                    handler: async () => {
                        try {
                            await authStore.logout();
                            router.push('/login');
                        } catch (error) {
                            console.error('Logout error:', error);
                        }
                    },
                },
            ],
        });

        await alert.present();
    };

    const handleRefresh = (event: RefresherCustomEvent) => {
        emit('refresh', event);
    };

    const ionInfinite = (event: InfiniteScrollCustomEvent) => {
        emit('loadMore');
        // Don't automatically complete the event - let the parent component decide
        // when to complete it based on if there's more data
        setTimeout(() => event.target.complete(), 1000);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { class: "ion-no-border" }, {
        default: _withCtx(() => [
          (!__props.hideHeader)
            ? (_openBlock(), _createBlock(_unref(IonToolbar), {
                key: 0,
                class: "px-6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonImg), _mergeProps({ src: "/assets/motorcentral-logo.svg" }, useAttrs(), { class: "h-5 w-33.75" }), null, 16),
                  (showSidebar.value && _unref(isMobile))
                    ? (_openBlock(), _createBlock(_unref(IonButtons), {
                        key: 0,
                        slot: "end"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            fill: "clear",
                            onClick: openMobileMenu
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Menu), { class: "size-6 text-white" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_unref(isMobile))
                    ? (_openBlock(), _createBlock(_unref(IonButtons), {
                        key: 1,
                        slot: "end",
                        class: "flex items-center"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonButton), {
                            fill: "clear",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/chat'))),
                            class: "!px-0"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_1, [
                                _createVNode(_unref(IonIcon), {
                                  slot: "icon-only",
                                  src: "/assets/nav/ic-message.svg",
                                  class: "size-11.5"
                                })
                              ])
                            ]),
                            _: 1
                          }),
                          (!__props.hideNotification)
                            ? (_openBlock(), _createBlock(_unref(IonButton), {
                                key: 0,
                                fill: "clear",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/notifications'))),
                                class: "!px-0 relative"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_unref(IonIcon), {
                                      slot: "icon-only",
                                      src: "/assets/nav/ic-notifications.svg",
                                      class: "size-6"
                                    })
                                  ]),
                                  (_unref(notificationStore).totalUnread > 0)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(notificationStore).totalUnread > 99 ? '99+' : _unref(notificationStore).totalUnread), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _renderSlot(_ctx.$slots, "action-button")
                        ]),
                        _: 3
                      }))
                    : _createCommentVNode("", true),
                  (!_unref(isMobile))
                    ? (_openBlock(), _createBlock(_unref(IonButtons), {
                        key: 2,
                        slot: "end",
                        class: "flex items-center"
                      }, {
                        default: _withCtx(() => [
                          (!__props.hideNotification)
                            ? (_openBlock(), _createBlock(_unref(IonButton), {
                                key: 0,
                                fill: "clear",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleLogout())),
                                class: "!px-0"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_unref(IonIcon), {
                                      slot: "icon-only",
                                      src: "/assets/nav/ic-logout.svg",
                                      class: "size-6"
                                    })
                                  ])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _renderSlot(_ctx.$slots, "action-button")
                        ]),
                        _: 3
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 3
              }))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "progress")
        ]),
        _: 3
      }),
      _createVNode(_unref(IonSplitPane), {
        when: "xs",
        "content-id": "main-content"
      }, {
        default: _withCtx(() => [
          (showSidebar.value)
            ? (_openBlock(), _createBlock(MobileMenu, {
                key: 0,
                class: "hidden sm:block"
              }))
            : _createCommentVNode("", true),
          _createVNode(_unref(IonContent), {
            id: "main-content",
            fullscreen: __props.fullscreen,
            class: _normalizeClass(`${__props.className}`)
          }, {
            default: _withCtx(() => [
              (__props.hasRefresh)
                ? (_openBlock(), _createBlock(_unref(IonRefresher), {
                    key: 0,
                    slot: "fixed",
                    onIonRefresh: _cache[3] || (_cache[3] = ($event: any) => (handleRefresh($event)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonRefresherContent))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "default")
              ]),
              (__props.withInfiniteScroll)
                ? (_openBlock(), _createBlock(_unref(IonInfiniteScroll), {
                    key: 1,
                    onIonInfinite: ionInfinite,
                    threshold: "0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonInfiniteScrollContent))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["fullscreen", "class"])
        ]),
        _: 3
      }),
      (_ctx.$slots.footer)
        ? (_openBlock(), _createBlock(_unref(IonFooter), { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonToolbar), null, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "footer")
                ]),
                _: 3
              })
            ]),
            _: 3
          }))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})